import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import PostJobContainer from '../postjob/PostJobContainer';
import { getTime } from '../../api/DataHandlers';
import { toggleModal } from '../../actions/ViewController';
import {
    fetchBookingRequestSeriesAsync,
    fetchPaygradeAsync,
    setBookingRequest,
    updateField,
} from '../../actions/BookingRequest';
import { TRootState } from '../../reducers';
import { executeHttpRequest } from '../../epics/api';
import history from '../../history';
import { getAllSkills } from '../../utils';
import { SERVER_URL } from '../../config';


export default function CheckoutPageContainer() {
    const dispatch = useDispatch();
    const { jobId } = useParams<{ jobId?: string }>();

    const {
        clientData,
        minStart,
        servicesStructure,
        user,
    } = useSelector((state: TRootState) => ({
        clientData: state.clientData,
        minStart: state.requestData.minStart,
        servicesStructure: state.servicesStructure,
        user: state.user,
    }));


    const initStateData = () => {
        const userType = clientData.userData.content.user_type;

        executeHttpRequest(`jobs/${jobId}/`, 'GET')
            .then(response => {
                const jobData = response.data.content;
                const { service, status, series } = jobData;
                let { date, start_time } = jobData;
                if (
                    status !== 'IC' ||
                    (userType === 'agent' && user.agency.features.indexOf('booking_tunnel') === -1) || 
                    userType === 'freelancer'
                ) {
                    window.location.href = `${SERVER_URL}/job/${jobId}/`;
                }

                if (moment(`${date} ${start_time}`).isBefore(minStart)) {
                    date = moment(minStart).format('YYYY-MM-DD');
                    start_time = getTime(minStart);
                }

                dispatch(updateField('service', service));
                dispatch(updateField('address1', jobData.address1));
                dispatch(updateField('address2', jobData.address2));
                dispatch(updateField('city', jobData.city));
                dispatch(updateField('postcode', jobData.postcode));
                dispatch(updateField('title', jobData.title));
                dispatch(updateField('admin_information', jobData.admin_information));
                dispatch(updateField('freelancers_information', jobData.freelancers_information));
                dispatch(updateField('nature_of_business', jobData.nature_of_business));
                dispatch(updateField('required_qualifications', jobData.required_qualifications));
                dispatch(updateField('safety_risks', jobData.safety_risks));
                dispatch(updateField('available_facilities', jobData.available_facilities));
                dispatch(updateField('expenses_payable', jobData.expenses_payable));
                dispatch(updateField('date', date));
                dispatch(updateField('duration', jobData.duration));
                dispatch(updateField('number_of_freelancers', jobData.number_of_freelancers));
                dispatch(updateField('recurrence_period', jobData.recurrence_period));
                dispatch(updateField('start_time', start_time));
                dispatch(updateField('voucher', jobData.voucher));

                if (series) {
                    dispatch(fetchBookingRequestSeriesAsync(series));
                } else {
                    dispatch(setBookingRequest([jobData]));
                }

                const roleExtras = getAllSkills(servicesStructure)
                    .reduce((result: {[key: string]: any}, skill) => ({
                        ...result,
                        [skill]: jobData[skill],
                    }), {});
                roleExtras.role = jobData.role;
                roleExtras.vehicle_type = jobData.vehicle_type;

                dispatch(fetchPaygradeAsync(service, start_time, date, roleExtras));
                const urlParams = new URLSearchParams(window.location.search);
                history.push({
                    state: {
                        mode: 'checkout',
                        stripeClientSecret: urlParams.get('payment_intent_client_secret'),
                    },
                });
                dispatch(toggleModal('paymentModal', true));
            })
            .catch(error => {
                // eslint-disable-next-line no-console
                console.log(error.response);
                history.push('/jobs/list');
            });
    };

    useEffect(() => initStateData(), []);

    return (
        <PostJobContainer mode="checkout" />
    );
}
